import { call, put } from 'redux-saga/effects'

import { convertOpeningGroupsToDrawableLocations } from './data-prep/convertOpeningsToDrawableLocations'
import { FETCH_OPENING_GROUPS_SUCCESS } from '../../../actions/drawable'
import { fetchProjectContextMarkups } from '../../../api/projects-api'
import { fetchOpeningGroupsByProjectId } from '../../../api/takeoff-api'
import { OpeningGroupAPI } from '../../../models/activeDrawable'
import { IToolObject } from '../../../models/tool'
import { setDrawableLocations } from '../../slices/2D'
import { setToolObjects } from '../../slices/tools'
import { IMUP2DDrawableLocation } from '../../types'

export function* hardUpdateProjectOpeningGroupsAndLocations(projectId: number) {
    const openingGroups: OpeningGroupAPI[] = yield call(fetchOpeningGroupsByProjectId, projectId)

    yield put({ type: FETCH_OPENING_GROUPS_SUCCESS, payload: openingGroups })

    const drawableLocations: IMUP2DDrawableLocation[] = yield call(
        convertOpeningGroupsToDrawableLocations,
        openingGroups
    )

    yield put(setDrawableLocations(drawableLocations))

    // Fetch tool objects from api
    const loadedToolObjects: IToolObject[] = yield call(fetchProjectContextMarkups, projectId)

    yield put(setToolObjects(loadedToolObjects))
}
